// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__JdO-1","info":"PatientInfo_info__213JS"};